export default __webpack_public_path__ + "static/media/notifiaction.37cec897.svg";